import { render, staticRenderFns } from "./step-5.vue?vue&type=template&id=139064ee"
import script from "./step-5.vue?vue&type=script&lang=js"
export * from "./step-5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports